import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const PRODUCT_LINKS = [
  { label: 'AI Voice Agents', to: '/products/voice-ai' },
  { label: 'Messaging', to: '/products/messaging' },
  { label: 'Web Chat Widget', to: '/products/web-chat' },
  { label: 'Voice Orb', to: '/products/voice-orb' },
  { label: 'Client Onboarding', to: '/products/client-onboarding' },
  { label: 'Leads & Outreach', to: '/products/leads-outreach' },
];

const ArcNav = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[min(1300px,calc(100%-2rem))]" data-testid="arc-nav">
      <div className="flex items-center justify-between rounded-2xl border border-black/[0.06] bg-[#F0EFEC]/80 backdrop-blur-xl px-5 py-3 shadow-sm">
        <Link to="/" className="flex items-center" data-testid="arc-nav-logo">
          <img src="/voxinity-logo-light.png?v=8" alt="Voxinity AI" className="h-6 sm:h-8 w-auto" />
        </Link>
        <nav className="flex items-center gap-2 sm:gap-5">
          <div
            className="relative hidden sm:block"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
          >
            <button
              onClick={() => setOpen(true)}
              onFocus={() => setOpen(true)}
              className="arc-body inline-flex items-center gap-1 text-sm sm:text-base font-bold text-[#141414]/70 hover:text-[#141414] transition-colors px-2 py-2"
              data-testid="arc-nav-product-btn"
            >
              Product
              <ChevronDown size={14} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
            </button>
            {open && (
              <div
                className="absolute left-0 top-full pt-2"
                data-testid="arc-nav-product-menu"
              >
                <div className="w-60 rounded-2xl border border-black/[0.06] bg-[#F0EFEC] shadow-[0_24px_60px_-24px_rgba(20,20,20,0.3)] p-2">
                  {PRODUCT_LINKS.map((item) => (
                    <Link
                      key={item.label}
                      to={item.to}
                      onClick={() => setOpen(false)}
                      className="arc-body block rounded-xl px-4 py-2.5 text-sm font-semibold text-[#141414]/70 hover:text-[#141414] hover:bg-black/[0.04] transition-colors"
                      data-testid={`arc-nav-product-${item.label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
          <Link
            to="/#industries"
            className="arc-body hidden sm:block text-sm sm:text-base font-bold text-[#141414]/70 hover:text-[#141414] transition-colors px-2"
            data-testid="arc-nav-industries-link"
          >
            Industries
          </Link>
          <Link
            to="/pricing"
            className="arc-body text-sm sm:text-base font-bold text-[#141414]/70 hover:text-[#141414] transition-colors px-2"
            data-testid="arc-nav-pricing-link"
          >
            Pricing
          </Link>
          <Link
            to="/login"
            className="arc-body whitespace-nowrap rounded-full bg-[#141414] text-[#F0EFEC] text-sm sm:text-base font-bold px-5 sm:px-6 py-2.5 sm:py-3 hover:bg-black transition-colors"
            data-testid="arc-nav-login-btn"
          >
            Login or Sign up
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default ArcNav;
